import axios from "axios";
import { API_CONFIG } from "../config/apiConfig";
import { User } from "../types/user";
import { ImportMappedUsersRequest } from "../types/module";

export const mappingService = {
  getMappedUsers: async (moduleId: string, distributorCode?: string): Promise<User[]> => {
    let url = `${API_CONFIG.BASE_URL}/Module/GetMappedUsers/${moduleId}`;
    const params: any = {};
    if (distributorCode) params.distributorCode = distributorCode;
    const response = await axios.get(url, { params });
    return response.data;
  },
  importMappedUsers: async (moduleId: string, users: ImportMappedUsersRequest[]): Promise<any> => {
    const response = await axios.post(`${API_CONFIG.BASE_URL}/Module/ImportMappedUsers/${moduleId}`, users);
    return response.data;
  },
}; 